export default __webpack_public_path__ + "static/media/LOTUS.b860f5ef.png";